// src/components/ErrorBoundary.jsx
import React from 'react';
import {startupText} from '../i18n/startup';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const text=this.props.text||startupText;
      return (
        <div role="alert" className="flex items-center justify-center min-h-[400px] p-4 bg-white dark:bg-gray-950 dark:text-gray-100">
          <div className="text-center">
            <div className="text-4xl mb-4">⚠️</div>
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">{text('error')}</h2>
            <p className="text-sm text-gray-500 mt-1">{text('help')}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              {text('reload')}
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
